module.exports = __webpack_public_path__ + "images/top-topics-image-overlay.svg";